import "core-js/modules/es.array.push.js";
import clickShowTag from '@/components/clickShowTag.vue';
import tagModel from '@/components/tagModel.vue';
import tagList from '@/components/tagList.vue';
import { columns } from './utils';
import { resultSelectList, statusSelectList, auditSelectList } from '../customerRecordManage/utils';
import { claimsList } from './request';
import { customerResource } from '@/views/system/customerManage/request';
import { mapState } from 'vuex';
import { insuranceResource } from '@/views/insurance/insuranceManage/request';
import { agencyResource } from '@/views/insurance/organizationalManage/request';
// import {applicationResource} from '@/views/customer/applicationManage/request';
import { structureList } from '@/views/organization/staffManage/request';
import { getIntermediary } from '@/views/customer/roleManage/request';
import { REPLACE_DEPARTMENT_FIELDS } from '@/views/customer/roleManage/utils';
import { getTags } from '@/views/system/labelManage/request';
export default {
  components: {
    clickShowTag,
    tagModel,
    tagList
  },
  data() {
    return {
      REPLACE_DEPARTMENT_FIELDS,
      columns,
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      resultSelectList,
      statusSelectList,
      auditSelectList,
      showItem: false,
      tagShow: false,
      form: {
        policyNo: '',
        insuranceId: undefined,
        result: undefined,
        status: undefined,
        createAt: '',
        isClose: undefined,
        applicationId: undefined,
        structureId: undefined,
        customerId: undefined,
        agencyId: undefined,
        tags: ''
      },
      tableData: [],
      policySelectList: [],
      productSelectList: [],
      organizationSelectList: [],
      structureSelectList: [],
      intermediarySelectList: [],
      tagData: [],
      tagList: []
    };
  },
  created() {
    this.getSelect();
    this.searchFun();
  },
  computed: {
    ...mapState({
      customerId: state => state.user.accountInfo.customerId
    })
  },
  methods: {
    async customerChange() {
      this.structureSelectList = [];
      this.form.structureId = undefined;
      if (this.form.customerId) {
        this.structureSelectList = await structureList({
          customerId: this.form.customerId
        });
        if (this.structureSelectList.length === 1 && (!this.structureSelectList[0].children || this.structureSelectList[0].children.length === 0)) {
          this.form.structureId = this.structureSelectList[0].id;
        }
      }
    },
    async getSelect() {
      this.policySelectList = await customerResource({
        customerId: this.customerId
      });
      this.productSelectList = await insuranceResource({});
      this.organizationSelectList = await agencyResource({});
      this.intermediarySelectList = await getIntermediary({
        type: 0
      });
      this.tagData = await getTags({
        class: 'CLAIM'
      });
    },
    async searchFun() {
      //   this.pagination.total = totalNum;
      this.pagination.current = 1;
      this.getListData();
    },
    async getListData() {
      const {
        items,
        totalNum
      } = await claimsList(Object.assign(this.form, {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      }));
      this.tableData = items;
      this.pagination.total = totalNum;
      let lastPage = Math.ceil(this.pagination.total / this.pagination.pageSize);
      if (this.pagination.page === lastPage + 1 && this.pagination.total % (this.pagination.pageSize * (this.pagination.page - 1)) === 0) {
        this.pagination.current -= 1;
        this.getListData();
      }
    },
    resetSearch() {
      this.form = {};
    },
    onDetail() {},
    tablePageChange(val) {
      this.pagination = val;
      this.getListData();
    },
    tagOk(arr, arr2, arrVaule) {
      this.form.tags = arrVaule;
      this.tagList = arr;
      console.log(arr, arr2, arrVaule);
      if (arr2.length != 0) {
        this.tagList.push(arr2);
      }
      this.searchFun();
    },
    tagListOk(arr, arr2, arrVaule) {
      this.tagData = arr;
      this.tagList = arr2;
      this.form.tags = arrVaule;
      this.searchFun();
    }
    // onDateChange(date, dateString) {
    //   this.form.createAt = dateString;
    // }
  }
};